import React, { useEffect, useState } from "react";
import { BASE_URL } from "../../variables/api";
import { Route, Routes, useNavigate } from "react-router-dom";
import { createBrowserHistory } from "history";

import "./Table.css";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import axios from "axios";
import Swal from "sweetalert2";

const Table = (props: any) => {
  const navigate = useNavigate();
  const history = createBrowserHistory();
  const [departments, setDepartments] = useState([]);
  const [add, setAdd] = useState(false);
  useEffect(() => {
    const table = $("#dataTable").DataTable({
      order: [],
    });
  }, [$]);

  useEffect(async () => {
    Swal.showLoading();
    $("#dataTable").DataTable().destroy();
    axios.get(`${BASE_URL}/tickets/getdepartments.php`).then((res) => {
      setDepartments(res.data.data);
      Swal.close();
    });
  }, []);

  const handleInputChange = (e, id) => {
    console.log(e.target.checked);
    Swal.showLoading();
    Swal.fire({
      title: "Do you want Save Your Changes ?",
      showDenyButton: true,
      confirmButtonText: `Confirm`,
      denyButtonText: `Cancel`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        axios
          .post(`${BASE_URL}/tickets/changedepartmentpermission.php`, {
            value: e.target.checked,
            id: id,
          })
          .then((res) => {
            setAdd(!add);
            Swal.fire("Saved Successfully", "", "success");
          });
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };
  return (
    <>
      <div className="table-responsive-sm">
        <table id="dataTable" className="table table-striped table-sm">
          <thead>
            <tr className="tr">
              <th className="th">ID</th>
              <th className="th">Department</th>
              <th className="th">Permission</th>
            </tr>
          </thead>
          <tbody style={props.style}>
            {departments?.map((department) => {
              return (
                <tr>
                  <td className="td">{department.id}</td>
                  <td className="td">{department.department}</td>
                  <td className="td">
                    {
                      <input
                        type="checkbox"
                        defaultChecked={
                          department.ticket === "1" ? true : false
                        }
                        onChange={(e) => handleInputChange(e, department.id)}
                      />
                    }
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};
export default Table;
